import { render, staticRenderFns } from "./boundary.vue?vue&type=template&id=4ce12cc0&"
import script from "./boundary.vue?vue&type=script&lang=js&"
export * from "./boundary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports